import { array, number, func } from 'prop-types';
import { useEffect } from 'react';
import ImageGallery from 'react-image-gallery';

import { getIsMobile } from 'utils/helpers';

import 'react-image-gallery/styles/css/image-gallery.css';

export function ImagesSlider({
  images, initIndex, setImageIndex,
}) {
  const imagesItems = images.map((image) => {
    const sources = [
      {
        srcSet: image.full.replace('.jpg', '.avif'),
        type: 'image/avif',
      },
      {
        srcSet: image.full.replace('.jpg', '.webp'),
        type: 'image/webp',
      },
      {
        srcSet: image.full,
        type: 'image/jpg',
      },
    ];
    return {
      thumbnail: image.xs,
      original: image.full,
      sources,
      originalAlt: image?.altText || '',
    };
  });

  const isMobile = getIsMobile();

  useEffect(() => {
    setTimeout(() => {
      // Puede ser que la pagina tenga 2 o más .ant-modal-wrap, asi que solo cogemos el del fullscreenContainer
      const container = document.getElementById('fullscreenContainer').closest('.ant-modal-wrap');

      let offset = 0;
      if (!isMobile) {
        offset = container.scrollHeight * 0.15;
      }

      container.scrollTo(0, container.scrollHeight - container.clientHeight - offset);
    }, 650);
  }, [ initIndex ]);

  return (
    <ImageGallery
      items={imagesItems}
      showThumbnails={false}
      showBullets={false}
      showPlayButton={false}
      showFullscreenButton={false}
      showIndex={true}
      startIndex={initIndex}
      lazyLoad={true}
      onSlide={setImageIndex}
      renderItem={ (item) => (
        <picture>
          {item.sources.map((source, index) => (
            <source key={index} srcSet={source.srcSet} type={source.type} media={source.media}/>
          ))}
          <img src={item.original} width='100%' />
        </picture>
      )}
    />
  );
}

ImagesSlider.propTypes = {
  images: array,
  initIndex: number,
  setImageIndex: func,
};

export default ImagesSlider;
